import resources from "@/business/deliveries/infrastructure/config/resources.json";
import { Resource, DeliveryActions } from "../../domain/deliveries";

export const getResourcesService = {
  async execute(): Promise<Resource[]> {
    const allResources = resources;

    return new Promise((resolve) => {
      resolve(
        allResources.map((resource) => {
          return DeliveryActions().resource(
            null,
            resource.name,
            resource.extension,
            resource.size,
          );
        })
      );
    });
  },
};
